import { useReactiveVar } from "@apollo/client";
import React, { useEffect, useState } from "react";
import niliveryLogo from "../assets/icons/niliveryLogo.svg";
import { GpsIcon, Arrow, XIcon } from "./Icons";
import {
  isLoggedInVar,
  pageIndicator,
  searchText,
  serviceId,
  serviceIsActive,
  serviceName,
  toolTipAlert,
} from "../apollo";
import {
  ArrowLeft,
  ArrowRight,
  CartIcon,
  CloseIcon,
  HomeIcon,
  SearchIcon,
} from "./Icons";
import { useNavigate } from "react-router-dom";
import { useMe } from "../hooks/useME";
import { useListBaksetItem } from "../hooks/useListBaksetMine";
import { useForm } from "react-hook-form";
import join_exit from "../assets/images/join_exit.png";
import { Dialog } from "@mui/material";
import { AlertComponent } from "./alert";
import { useListAddress } from "../hooks/useListAddress";
import {
  ListAddressQuery,
  ListBasketItemQuery,
  ListBasketItemServiceQuery,
} from "../gql/graphql";
import { ListRegion } from "./list-region";
import {
  GetLinkServiceNearQuery,
  useGetLinkServiceNear,
} from "../hooks/useGetLinkServiceNear";
import { useListBasketItemService } from "../hooks/useListBasketItemService";

interface TopBarProps {
  arrow?: boolean;
  arrowColor?: string;
  close?: boolean;
  closeColor?: string;
  heading?: boolean;
  headingColor?: string;
  search?: boolean;
  home?: boolean;
  homeColor?: string;
  homeRight?: boolean;
  main?: boolean;
  searchColor?: string;
  shop?: boolean;
  shopColor?: string;
  exit?: boolean;
  backColor?: string;
  address?: boolean;
  emart?: boolean;
  location?: boolean;
  arrowFunction?: () => void;
}

export const TopBar: React.FC<TopBarProps> = ({
  arrow,
  arrowColor,
  arrowFunction,
  close,
  closeColor,
  heading,
  home,
  homeColor,
  homeRight,
  shop,
  shopColor,
  exit,
  backColor,
  location,
}) => {
  const { data: me } = useMe();
  const isLoggedIn = useReactiveVar(isLoggedInVar);
  const goBack = () => {
    navigate(-1);
  };
  const [alertOpen, setAlertOpen] = useState(false);
  const [listRegionOpen, setListRegionOpen] = useState(false);
  const [tooltipText, setTooltipText] = useState("받으실 곳이 맞나요?");
  const [tooltipOpen, setTooltipOpen] = useState(false);
  
  const topbar_serviceName = useReactiveVar(serviceName);
  const topbar_serviceId = useReactiveVar(serviceId);
  const topbar_serviceIsActive = useReactiveVar(serviceIsActive);
  console.log(topbar_serviceIsActive);
  const toolTipShow = useReactiveVar(toolTipAlert);
  const closeAlert = () => {
    setAlertOpen(false);
    navigate("/login");
  };
  useEffect(() => {
    if(topbar_serviceIsActive === false){
      setTooltipText("지금 서비스하지 않고 있어요!");
      setTooltipOpen(true);
    }
    if(topbar_serviceIsActive === true){
      setTooltipText("받으실 곳이 맞나요?");
      setTooltipOpen(true);
    }
  }, [topbar_serviceIsActive]);
  const onCompleted = async (data: ListBasketItemServiceQuery) => {
    const {
      listBasketItemService: { ok, err },
    } = data;
    if (ok) {
      await refetch();
    }
  };

  const [
    listBasketItemService,
    { data: listBasketItemServiceData, loading, refetch },
  ] = useListBasketItemService(onCompleted);
  const navigate = useNavigate();
  const listBasketItemServiceHandler = (serviceId: number) => {
    listBasketItemService({ variables: { input: { serviceId } } });
  };
  const [service, setService] =
    useState<GetLinkServiceNearQuery["getLinkServiceNear"]["linkservice"]>();
  const [latitude, setLatitude] = useState<number>();
  const [longitude, setLongitude] = useState<number>();

  const getGeoLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
      },
      (error) => {
        setLatitude(36.12316);
        setLongitude(128.184984);
        console.error("위치 가져오기 실패:", error);
        setTooltipOpen(true);
      },
      {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 300000,
      }
    );
  };

  const onGetLinkServiceNearCompleted = (data: GetLinkServiceNearQuery) => {
    const {
      getLinkServiceNear: { ok, err, linkservice },
    } = data;
    if (ok && linkservice) {
      setService(linkservice);
      serviceId(Number(linkservice.id));
      serviceName(linkservice.name || "");
      serviceIsActive(linkservice.isActive);
      if (linkservice.isActive === false && toolTipShow) {
        setTooltipText("지금 서비스하지 않고 있어요!");
        setTooltipOpen(true);
      }
      if (linkservice.distance > 500 && toolTipShow) {
        setTooltipOpen(true);
      }
    }
  };
  const [getLinkServiceNear, { data: getLinkServiceNearData }] =
    useGetLinkServiceNear(onGetLinkServiceNearCompleted);

  const getLinkServiceNearHandler = () => {
    getLinkServiceNear({
      variables: {
        input: {
          latitude: latitude,
          longitude: longitude,
        },
      },
    });
  };

  useEffect(() => {
    if (topbar_serviceId === 0) {
      getGeoLocation();
    } else if (topbar_serviceId && isLoggedIn) {
      listBasketItemServiceHandler(topbar_serviceId);
    }
  }, []);

  useEffect(() => {
    if (latitude && longitude) {
      getLinkServiceNearHandler();
    }
  }, [latitude, longitude]);

  useEffect(() => {
    if (topbar_serviceId && isLoggedIn) {
      listBasketItemServiceHandler(topbar_serviceId);
    }
  }, [topbar_serviceId]);

  return (
    <div
      className={`max-w-screen-break break:max-w-screen-fit mx-auto w-full h-[48px] flex flex-wrap content-center relative z-[2] ${
        backColor ? `bg-[${backColor}]` : "bg-mainIcon"
      }`}
    >
      <div className="px-3 py-1 w-full h-full flex flex-wrap justify-between gap-x-2">
        <div className="flex-1 flex flex-wrap gap-x-[14px]">
          {arrow && (
            <div className="w-8 h-8 my-1 flex flex-wrap content-center">
              <button
                onClick={arrowFunction ? arrowFunction : goBack}
                className="w-full h-8 "
              >
                {arrowColor ? <ArrowLeft color={arrowColor} /> : <ArrowLeft />}
              </button>
            </div>
          )}
          {close && (
            <div className="w-8 h-10 flex flex-wrap content-center ">
              <button onClick={() => navigate(-1)} className="w-full h-8 ">
                {closeColor ? <CloseIcon color={closeColor} /> : <CloseIcon />}
              </button>
            </div>
          )}
          {home && (
            <div
              className={`h-10 flex flex-wrap  content-center ${
                homeRight ? "flex-1 justify-end" : ""
              } `}
            >
              <button
                onClick={() => {
                  navigate("/");
                }}
                className="w-8 h-8 "
              >
                {homeColor ? <HomeIcon color={homeColor} /> : <HomeIcon />}
              </button>
            </div>
          )}
          {heading && (
            <div className=" w-32 flex content-center items-center">
              <h2>
                <img src={niliveryLogo} alt="닐리버리" />
              </h2>
            </div>
          )}
          {location && (
            <>
              <div
                onClick={() => setListRegionOpen(true)}
                className="flex content-center items-center relative cursor-pointer"
              >
                <GpsIcon color={topbar_serviceIsActive ? "white" : "red"} />
                <div
                  className={` text-sm font-bold flex-1 whitespace-nowrap overflow-hidden ml-2 ${
                    topbar_serviceIsActive ? "text-white" : "text-grayFont opacity-50"
                  }`}
                >
                  <p className={`w-full truncate`}>{topbar_serviceName}</p>
                </div>
                <ArrowRight
                  color={topbar_serviceIsActive ? "white" : "grayFont opacity-50"}
                  className="ml-2 w-5"
                />
              </div>
              <div
                className={`absolute -bottom-[20px] left-4 transition-all duration-300 ease-in-out
                ${tooltipOpen ? "block" : "hidden"}
                `}
              >
                <Arrow
                  color="white"
                  className="rotate-180 absolute -top-[10px] left-[20px]"
                />
                <div
                  className={`w-fit h-full flex items-center justify-center bg-white rounded-full py-1 px-2
                  `}
                >
                  <p className="text-xs font-bold">
                    {tooltipText}
                    <button
                      onClick={() => setTooltipOpen(false)}
                      className="pl-1 align-top"
                    >
                      <XIcon />
                    </button>
                  </p>
                </div>
              </div>
              <Dialog
                open={listRegionOpen}
                onClose={() => setListRegionOpen(false)}
                className="relative"
              >
                <ListRegion
                  listRegionOpen={listRegionOpen}
                  setListRegionOpen={setListRegionOpen}
                />
              </Dialog>
            </>
          )}
        </div>
        <div>
          {shop && (
            <div className="w-6 h-10 flex flex-wrap content-center ">
              <button
                onClick={() => {
                  if (me) {
                    navigate(`/baskets/${serviceId()}`);
                  } else {
                    setAlertOpen(true);
                    // alert("로그인/회원가입 후 이용해주세요.");
                    // navigate("/login");
                  }
                }}
                className="w-full h-8 relative"
              >
                <CartIcon color={shopColor} />
                {listBasketItemServiceData?.listBasketItemService
                  ?.basketItems &&
                  listBasketItemServiceData?.listBasketItemService?.basketItems
                    .length > 0 && (
                    <span
                      className={`absolute flex flex-wrap content-center justify-center left-1/2 top-0 w-[17px] h-[16px] ${
                        shopColor ? `bg-${shopColor}` : `bg-white`
                      } text-center ${
                        shopColor ? `text-white` : `text-mainIcon`
                      } text-Xsmall rounded-full`}
                    >
                      {listBasketItemServiceData?.listBasketItemService?.basketItems.length
                        .toString()
                        .padStart(2, "0")}
                    </span>
                  )}
              </button>
            </div>
          )}
          {exit && (
            <div className="w-8 h-8 my-1 flex flex-wrap content-center">
              <button
                onClick={arrowFunction ? arrowFunction : goBack}
                className="w-full h-8 "
              >
                <img
                  src={join_exit}
                  alt="exit 이미지"
                  className="w-full h-full"
                />
              </button>
            </div>
          )}
        </div>
      </div>
      <Dialog
        open={alertOpen}
        onClose={() => {
          setAlertOpen(false);
        }}
        className="relative"
      >
        <AlertComponent
          title={`안내`}
          desc={`로그인/회원가입 후 이용해주세요.`}
          closeFunction={closeAlert}
        ></AlertComponent>
      </Dialog>
    </div>
  );
};
